/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerDTO,
  GetProductsParams,
  ProductDTO,
  SearchCustomersParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get a specific customer by branch and customer number
 * @summary Get customer
 */
export const getCustomer = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerDTO>(
      {url: `/api/frontend/customers/${branch}/${custNo}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomerInfiniteQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    'infinite', `/api/frontend/customers/${branch}/${custNo}`
    ] as const;
    }

export const getGetCustomerQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    `/api/frontend/customers/${branch}/${custNo}`
    ] as const;
    }

    
export const getGetCustomerInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomer>>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerInfiniteQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerInfiniteQueryError = unknown


export function useGetCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer
 */

export function useGetCustomerInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomer>>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerInfiniteQueryOptions(branch,custNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerQueryOptions = <TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomer>>> = ({ signal }) => getCustomer(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomer>>>
export type GetCustomerQueryError = unknown


export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomer>>,
          TError,
          Awaited<ReturnType<typeof getCustomer>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer
 */

export function useGetCustomer<TData = Awaited<ReturnType<typeof getCustomer>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomer>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get products for a specific customer
 * @summary Get customer products
 */
export const getProducts = (
    branch: string,
    custNo: string,
    params: GetProductsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/${branch}/${custNo}/products`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetProductsInfiniteQueryKey = (branch?: string,
    custNo?: string,
    params?: GetProductsParams,) => {
    return [
    'infinite', `/api/frontend/customers/${branch}/${custNo}/products`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetProductsQueryKey = (branch?: string,
    custNo?: string,
    params?: GetProductsParams,) => {
    return [
    `/api/frontend/customers/${branch}/${custNo}/products`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetProductsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsInfiniteQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsInfiniteQueryError = unknown


export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer products
 */

export function useGetProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProducts>>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductsInfiniteQueryOptions(branch,custNo,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProductsQueryOptions = <TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductsQueryKey(branch,custNo,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProducts>>> = ({ signal }) => getProducts(branch,custNo,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getProducts>>>
export type GetProductsQueryError = unknown


export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProducts>>,
          TError,
          Awaited<ReturnType<typeof getProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer products
 */

export function useGetProducts<TData = Awaited<ReturnType<typeof getProducts>>, TError = unknown>(
 branch: string,
    custNo: string,
    params: GetProductsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductsQueryOptions(branch,custNo,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get loan products for a specific customer
 * @summary Get loan products
 */
export const getLoansProducts = (
    branch: string,
    custNo: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/${branch}/${custNo}/loan-products`, method: 'GET', signal
    },
      options);
    }
  



export const getGetLoansProductsInfiniteQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    'infinite', `/api/frontend/customers/${branch}/${custNo}/loan-products`
    ] as const;
    }

export const getGetLoansProductsQueryKey = (branch?: string,
    custNo?: string,) => {
    return [
    `/api/frontend/customers/${branch}/${custNo}/loan-products`
    ] as const;
    }

    
export const getGetLoansProductsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getLoansProducts>>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoansProductsInfiniteQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoansProducts>>> = ({ signal }) => getLoansProducts(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoansProductsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getLoansProducts>>>
export type GetLoansProductsInfiniteQueryError = unknown


export function useGetLoansProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansProducts>>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansProducts>>,
          TError,
          Awaited<ReturnType<typeof getLoansProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansProducts>>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansProducts>>,
          TError,
          Awaited<ReturnType<typeof getLoansProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansProducts>>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan products
 */

export function useGetLoansProductsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getLoansProducts>>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoansProductsInfiniteQueryOptions(branch,custNo,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetLoansProductsQueryOptions = <TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLoansProductsQueryKey(branch,custNo);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLoansProducts>>> = ({ signal }) => getLoansProducts(branch,custNo, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch && custNo), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLoansProductsQueryResult = NonNullable<Awaited<ReturnType<typeof getLoansProducts>>>
export type GetLoansProductsQueryError = unknown


export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansProducts>>,
          TError,
          Awaited<ReturnType<typeof getLoansProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLoansProducts>>,
          TError,
          Awaited<ReturnType<typeof getLoansProducts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get loan products
 */

export function useGetLoansProducts<TData = Awaited<ReturnType<typeof getLoansProducts>>, TError = unknown>(
 branch: string,
    custNo: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLoansProducts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLoansProductsQueryOptions(branch,custNo,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Search for customers by query
 * @summary Search customers
 */
export const searchCustomers = (
    branch: string,
    params: SearchCustomersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerDTO[]>(
      {url: `/api/frontend/customers/search/${branch}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getSearchCustomersInfiniteQueryKey = (branch?: string,
    params?: SearchCustomersParams,) => {
    return [
    'infinite', `/api/frontend/customers/search/${branch}`, ...(params ? [params]: [])
    ] as const;
    }

export const getSearchCustomersQueryKey = (branch?: string,
    params?: SearchCustomersParams,) => {
    return [
    `/api/frontend/customers/search/${branch}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getSearchCustomersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof searchCustomers>>>, TError = unknown>(branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCustomersInfiniteQueryKey(branch,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCustomers>>> = ({ signal }) => searchCustomers(branch,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchCustomersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof searchCustomers>>>
export type SearchCustomersInfiniteQueryError = unknown


export function useSearchCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCustomers>>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCustomers>>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCustomers>>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search customers
 */

export function useSearchCustomersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof searchCustomers>>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchCustomersInfiniteQueryOptions(branch,params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getSearchCustomersQueryOptions = <TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchCustomersQueryKey(branch,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchCustomers>>> = ({ signal }) => searchCustomers(branch,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(branch), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type SearchCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof searchCustomers>>>
export type SearchCustomersQueryError = unknown


export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchCustomers>>,
          TError,
          Awaited<ReturnType<typeof searchCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Search customers
 */

export function useSearchCustomers<TData = Awaited<ReturnType<typeof searchCustomers>>, TError = unknown>(
 branch: string,
    params: SearchCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getSearchCustomersQueryOptions(branch,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a list of all products
 * @summary Get all products
 */
export const getAllProducts2 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/products`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllProducts2InfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/customers/products`
    ] as const;
    }

export const getGetAllProducts2QueryKey = () => {
    return [
    `/api/frontend/customers/products`
    ] as const;
    }

    
export const getGetAllProducts2InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllProducts2>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProducts2InfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProducts2>>> = ({ signal }) => getAllProducts2(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProducts2InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllProducts2>>>
export type GetAllProducts2InfiniteQueryError = unknown


export function useGetAllProducts2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProducts2>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts2>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProducts2>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts2>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProducts2>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all products
 */

export function useGetAllProducts2Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllProducts2>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProducts2InfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllProducts2QueryOptions = <TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllProducts2QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllProducts2>>> = ({ signal }) => getAllProducts2(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllProducts2QueryResult = NonNullable<Awaited<ReturnType<typeof getAllProducts2>>>
export type GetAllProducts2QueryError = unknown


export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts2>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllProducts2>>,
          TError,
          Awaited<ReturnType<typeof getAllProducts2>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all products
 */

export function useGetAllProducts2<TData = Awaited<ReturnType<typeof getAllProducts2>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllProducts2>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllProducts2QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get products filtered by type
 * @summary Get products by type
 */
export const getProductByType = (
    product: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ProductDTO[]>(
      {url: `/api/frontend/customers/products/by-type/${product}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetProductByTypeInfiniteQueryKey = (product?: string,) => {
    return [
    'infinite', `/api/frontend/customers/products/by-type/${product}`
    ] as const;
    }

export const getGetProductByTypeQueryKey = (product?: string,) => {
    return [
    `/api/frontend/customers/products/by-type/${product}`
    ] as const;
    }

    
export const getGetProductByTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getProductByType>>>, TError = unknown>(product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductByTypeInfiniteQueryKey(product);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductByType>>> = ({ signal }) => getProductByType(product, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(product), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductByTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getProductByType>>>
export type GetProductByTypeInfiniteQueryError = unknown


export function useGetProductByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductByType>>>, TError = unknown>(
 product: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByType>>,
          TError,
          Awaited<ReturnType<typeof getProductByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductByType>>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByType>>,
          TError,
          Awaited<ReturnType<typeof getProductByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductByType>>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get products by type
 */

export function useGetProductByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getProductByType>>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductByTypeInfiniteQueryOptions(product,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetProductByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductByTypeQueryKey(product);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductByType>>> = ({ signal }) => getProductByType(product, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(product), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetProductByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductByType>>>
export type GetProductByTypeQueryError = unknown


export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByType>>,
          TError,
          Awaited<ReturnType<typeof getProductByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductByType>>,
          TError,
          Awaited<ReturnType<typeof getProductByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get products by type
 */

export function useGetProductByType<TData = Awaited<ReturnType<typeof getProductByType>>, TError = unknown>(
 product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetProductByTypeQueryOptions(product,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




